import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_BUSINESS_INFO = gql`
  query BusinessEntityInfo($businessEntityUuid: UUID!) {
    businessEntity(businessEntityUuid: $businessEntityUuid) {
      name
      planType
      nameInitials
      formationDate
      ein
    }
  }
`;
